export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/spokesperson_fr-FR.41a6117.vtt";